export { default } from './HighlightedCell';
